module.exports = __webpack_public_path__ + "img/bg.69dbbca3.jpg";